module.exports = "/images/es-pv.svg?7b7c559237c7543409c9b25e4d6b2240";